// extracted by mini-css-extract-plugin
module.exports = {"redditEmbed":"style_redditEmbed__C_8l7","fallback":"style_fallback__KrxIr g-grid-container"};